import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../services/master/MasterService'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import { FaDownload } from 'react-icons/fa'
import DataTable from 'react-data-table-component'
import Bentuk from '../../utilities/Bentuk'
import IkanKelompok from '../../utilities/IkanKelompok'

const MasterIkanModal = ({ showIkanModal, handleCloseIkanModal, setDisableForm }) => {

    let masterService = useMemo(() => new MasterService(), [])
    const columns = [
        {
            name: 'Nama Dagang',
            cell: row => row['nmDagang']
        },
        {
            name: 'Nama Latin',
            cell: row => row['nmLatin']
        },
        {
            name: 'HS Code',
            cell: row => row['hscode']
        },
        {
            name: 'Konsumsi',
            cell: row => (row['konsumsi'] === 'K' ? 'Konsumsi' : 'Non Konsumsi')
        },
        {
            name: 'Tawar',
            cell: row => (row['tawar'] === 'L' ? 'Laut' : 'Tawar')
        },
        {
            name: 'Bentuk',
            cell: row => <Bentuk idBentuk={row['bentuk']}/>
        },
        {
            name: 'Kelompok',
            cell: row => <IkanKelompok id={row['idKelIkan']} />
        },
        {
            name: 'Satuan',
            cell: row => <>{row['kdSatuan']} - {row['uraianSatuan']}</>
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Pilih</Tooltip>}>

                            <Button size="sm" variant="primary" onClick={() => pilihDataIkan(row)}>
                                <FaDownload /> Pilih
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            )
        }
    ]

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const pilihDataIkan = (row) => {
        setDisableForm(true)
        handleCloseIkanModal(row)
    }

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true)
                const resIkan = await masterService.listMasterIkan(null, null, null, 0, 10)
                setListData(resIkan.data.data)
                setTotalData(resIkan.data.totalData)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                setListData([])
            }
        }
        fetchAllData()
    }, [masterService])

    const handleChangePage = async (page) => {
        setLoading(true)
        const resIkan = await masterService.listMasterIkan(null, null, null, page, 10)
        setListData(resIkan.data.data)
        setTotalData(resIkan.data.totalData)
        setLoading(false)
    }

    const handlePerRowsChange = async (size, page) => {
        setLoading(true)
        const _res = await masterService.listMasterIkan(null, null, null, page - 1, 10)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }

    const onChangeSearchIkan = async (e) => {
        setLoading(true)
        const _res = await masterService.listMasterIkan(e.target.value, null, null, 0, 10)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }


    return (
        <>
            <Modal
                show={showIkanModal}
                onHide={handleCloseIkanModal}
                backdrop='static'
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Header>
                    <h6>Pilih Data Ikan</h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Cari Nama Dagang</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="Nama Dagang" className="form-control-sm" onChange={(e) => onChangeSearchIkan(e)} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="table-responsive border-bottom my-3">
                        {loading && <Spinner />}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listData}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={totalData}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            persistTableHead={true}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MasterIkanModal